import { useCallback, useContext, useEffect } from 'react';

import { GenericDataFormContext, LoadSavedQuotations, LoadSavedQuotationsCard, QuotationInfoContext, QuotationStep } from '../../../shared';
import { LOADING_SAVED_QUOTATIONS_STATES } from '../../../shared/interfaces/loading-saved-quotations-states-enum';

import './index.css';

export const LoadSavedQuotation = () => {
  const {
    loadSaveQuotationState,
    setLoadSaveQuotationState,
    setCurrentStep,
    setLoadingSavedQuotation,
    savedQuotation
  } = useContext(QuotationInfoContext);
  const { setPlansSelected } = useContext(GenericDataFormContext);

  const fillCommonStep = useCallback(() => {
    const { bienes = [] } = savedQuotation as LoadSavedQuotations;

    const plansSelecteds: Array<string> = [];

    bienes.forEach(({ planSeleccionado }) => {
      if (!plansSelecteds.includes(String(planSeleccionado))) {
        plansSelecteds.push(String(planSeleccionado));
      };
    });

    setPlansSelected(plansSelecteds);
  }, [savedQuotation, setPlansSelected]);
  
  useEffect(() => {
    setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.INIT_LOADING);
    fillCommonStep();
  }, []);

  useEffect(() => {
    if (loadSaveQuotationState === LOADING_SAVED_QUOTATIONS_STATES.STEP_THREE_DATA_FILLED) {
      setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.FINISH_LOADING);
      setLoadingSavedQuotation(false);
      setCurrentStep(QuotationStep.THREE);
    }
  }, [loadSaveQuotationState]);
 

  return <LoadSavedQuotationsCard />;
};
